import axios from "../../lib/axios";
import * as types from "src/types/auth";
import { ApiResponse } from "src/types/common";

export const getUserProfile = (): Promise<ApiResponse<types.UserProfile>> =>
    axios.get("/api/v1/account/getProfile").then(res => res.data);